(function() {
  "use strict";

  angular
    .module("sempraWebapp")
    .controller("dashboardTechnologyController", dashboardTechnologyController);

  /** @ngInject */
  function dashboardTechnologyController(
    $scope,
    deviceActions,
    messageActions,
    DashboardTechnologyViewModel,
    broker,
    webSocketsStore,
    messagesStore,
    $timeout,
    layoutActions,
    $mdDialog,
    hostProtocol,
    hostDomain,
    $log,
    $translate,
    sessionData,
    $state,
    brand,
    service,
    karcherActiveAlarmsService
  ) {
    var vm = this,
      _webSocketStoreConnectedChangeHandler = subscribeToSocket,
      _onDeviceDataChangeHandler = refreshDevice,
      _onFeedChangedHandler = refreshDeviceFeed;
    //_onMessageAvailableHandler = refreshMessages;

    var brandSubTitle = brand === "karcher" ? "Kärcher Car Wash" : "R2W";

    vm.dashboard = null;

    vm.brand = brand;
    vm.service = service;

    vm.openCarWashDetails = function(ev, facility) {
      $mdDialog.show({
        controller: facilityDetailsController,
        controllerAs: "vm",
        bindToController: true,
        templateUrl: "app/dashboardTechnology/facilityDetailView.dialog.html",
        /* eslint-disable */
        parent: angular.element(document.body),
        /* eslint-enable */
        targetEvent: ev,
        locals: { facility: facility },
        clickOutsideToClose: true
      });
    };

    vm.details = function(id, status, deviceType) {
      $state.go("app.dashboardTechnology.facilityDetails", {
        id: id,
        deviceType: deviceType.toLowerCase()
      });
    };

    // to-do implement this in a separate file (dialog to be separate component)
    function facilityDetailsController($mdDialog, Upload, facility, $mdToast) {
      /* eslint-disable */
      var that = this;
      /* eslint-enable */

      var facilityId = that.facility.pointId;

      that.data = {};
      that.imageLink =
        hostProtocol +
        "://" +
        hostDomain +
        "/api/washFacilities/" +
        facilityId +
        "/image";

      deviceActions.getDeviceDetails(facilityId).then(function(data) {
        data.website =
          data.website === "" ? (data.website = "http://") : data.website;
        that.data = data;
      });

      that.submit = function() {
        if (that.scope.facilityDetailsForm.file.$valid && that.scope.file) {
          uploadImage(that.scope.file);
        }
      };

      that.saveChanges = function() {
        var request = {
          address: that.data.address,
          phone1: that.data.phone1,
          phone2: that.data.phone2,
          website: that.data.website,
          workingHours: that.data.workingHours,
          info: that.data.info
        };
        deviceActions.updateDeviceDetails(facilityId, request).then(function() {
          $mdToast.show(
            $mdToast
              .simple()
              .textContent(
                $translate.instant("FACILITY_UPDATE_DATA_NOTIFICATION")
              )
              .position("bottom right")
              .hideDelay(3000)
          );
          that.closeDialog();
        });
      };

      that.closeDialog = function() {
        $mdDialog.hide();
      };

      function uploadImage(file) {
        Upload.upload({
          url:
            hostProtocol +
            "://" +
            hostDomain +
            "/api/washFacilities/" +
            facilityId +
            "/image",
          data: { file: file }
        }).then(
          function(resp) {
            $log.info(
              "Success " +
                resp.config.data.file.name +
                "uploaded. Response: " +
                resp.data
            );

            $mdToast.show(
              $mdToast
                .simple()
                .textContent(
                  $translate.instant("FACILITY_UPLOAD_IMAGE_NOTIFICATION")
                )
                .position("bottom right")
                .hideDelay(3000)
            );
          },
          function(resp) {
            $log.info("Error status: " + resp.status);
          },
          function(evt) {
            var progressPercentage = parseInt((100.0 * evt.loaded) / evt.total);
            $log.info(
              "progress: " +
                progressPercentage +
                "% " +
                evt.config.data.file.name
            );
          }
        );
      }
    }

    init();

    function init() {
      //Load title =======================================
      /* eslint-disable */
      var title = document.getElementsByTagName("title");
      /* eslint-enable */
      var check = sessionData.getTitle().firstName;
      title[0].innerHTML = !check
        ? "Merchant - " + brandSubTitle
        : sessionData.getTitle().firstName +
          " " +
          sessionData.getTitle().lastName +
          " " +
          "- " +
          brandSubTitle;
      //==================================================

      layoutActions.showLoader();
      $scope.$on("$destroy", destroy);

      deviceActions.getAllDevices().then(
        function(devicesJson) {
          layoutActions.hideLoader();
          vm.dashboard = new DashboardTechnologyViewModel(devicesJson);

          subscribeToSocket();
          webSocketsStore.on(
            webSocketsStore.events.CONNECTED_CHANGE,
            _webSocketStoreConnectedChangeHandler
          );
          webSocketsStore.on(
            webSocketsStore.events.DEVICE_FEED_CHANGE,
            _onFeedChangedHandler
          );
          webSocketsStore.on(
            webSocketsStore.events.DEVICE_STATE_CHANGE,
            _onDeviceDataChangeHandler
          );

          // If Karcher brand is define, get active alarms
          if (brand === "karcher") {
            messageActions.getKarcherAlarms().then(function(data) {
              vm.karcherActiveAlarms = data;
              vm.dashboard.devices = karcherActiveAlarmsService.checkFacilityStatus(data, vm.dashboard.devices);
            });
          }

        },
        function() {
          //todo error handling
        }
      );
      // showReleaseAlert();
    }

    function destroy() {
      if (vm.dashboard !== null) {
        vm.dashboard.destroy();
        webSocketsStore.off(
          webSocketsStore.events.CONNECTED_CHANGE,
          _webSocketStoreConnectedChangeHandler
        );
        webSocketsStore.off(
          webSocketsStore.events.DEVICE_FEED_CHANGE,
          _onFeedChangedHandler
        );
        webSocketsStore.off(
          webSocketsStore.events.DEVICE_STATE_CHANGE,
          _onDeviceDataChangeHandler
        );
        // webSocketsStore.off(webSocketsStore.events.MESSAGES_UPDATE_AVAILABLE, _onMessageAvailableHandler);
      }
    }

    function subscribeToSocket() {
      if (webSocketsStore.isConnected()) {
        var deviceSerialArray = vm.dashboard.devices.map(function(
          deviceTileViewModel
        ) {
          return deviceTileViewModel.deviceSerial;
        });
        broker.subscribeToDeviceChanges(deviceSerialArray);
        broker.subscribeToFeedChanges(deviceSerialArray);
        broker.subscribeToNoticeChanges();
        // broker.subscribeToMessageChanges(deviceSerialArray);
      }
    }

    function refreshDevice(newDeviceData) {
      $timeout(function() {
        vm.dashboard.refreshTileDevice(newDeviceData);
      }, 50);
    }

    function refreshDeviceFeed(newFeedData) {
      $timeout(function() {
        vm.dashboard.refreshTileDeviceFeed(newFeedData);
      }, 50);
    }

    // function showReleaseAlert() {
    //   var alert = $mdDialog.alert({
    //     title: "Attention",
    //     textContent: "Update process on wash facilities is in progress. Thanks for your patience on this issue.",
    //     ok: "Close"
    //   });
    //
    //   $mdDialog.show(alert).finally(function() {
    //     alert = undefined;
    //   });
    // }

    // function refreshMessages () {
    //   vm.dashboard.refreshAlarms();
    // }
  }
})();
